import { cn } from "@/lib/utils";

interface AuthCardProps {
  children: React.ReactNode;
  size?: "md" | "lg";
}

export function AuthCard({ children, size = "md" }: AuthCardProps) {
  const maxWidth = size === "lg" ? "max-w-lg" : "max-w-md";

  return (
    <div className={cn("w-full px-4 sm:px-0", maxWidth)}>
      <div className="animate-fade-in w-full rounded-lg border border-neutral-200 bg-white p-6 shadow-sm md:p-8">
        {children}
      </div>
    </div>
  );
}
